import { useState } from "react";
import { useAppStore } from "../lib/store";
import { trackEvent } from "../lib/analytics";
import { useTranslation } from "react-i18next";
import { SvgIcon } from "./ui/SvgIcon";
import checkIcon from "../assets/check-icon.svg?raw";

interface CopyLinkProps {
  className?: string;
}

export function CopyLink({ className = "" }: CopyLinkProps) {
  const [copied, setCopied] = useState(false);
  const isDark = useAppStore((state) => state.isDark);
  const { t } = useTranslation();

  const handleCopy = async () => {
    trackEvent("copy-lobby-code");
    await navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={`${className}`}>
      <button
        type="button"
        onClick={handleCopy}
        className={`flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap ${isDark ? "text-zinc-400" : "text-gray-500"}`}
      >
        {copied ? (
          <SvgIcon markup={checkIcon} size={16} className="shrink-0" />
        ) : (
          <svg
            className="w-4 h-4 shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
            />
          </svg>
        )}
        <span className="text-sm font-medium">
          {copied
            ? t("components.copyLink.copied")
            : t("components.copyLink.inviteLink")}
        </span>
      </button>
    </div>
  );
}
